import React, { useState, useEffect } from 'react';
import { useTranslation } from '../LanguageContext';

const GA_ID = 'G-PMS1TLW3K2';

function loadGA() {
  if (window._gaLoaded) return;
  window._gaLoaded = true;
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.async = true;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID, { anonymize_ip: true });
}

function CookieConsent() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (consent === 'accepted') {
      loadGA();
    } else if (!consent) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    loadGA();
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: '#1a1a2e',
      borderTop: '1px solid rgba(255,255,255,0.1)',
      padding: '14px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '16px',
      flexWrap: 'wrap',
      zIndex: 9999,
      boxShadow: '0 -4px 20px rgba(0,0,0,0.3)',
    }}>
      <p style={{
        margin: 0,
        fontSize: '13px',
        color: 'rgba(255,255,255,0.75)',
        lineHeight: '1.5',
        flex: 1,
        minWidth: '200px',
      }}>
        🍪 {t('cookie.text')}
      </p>
      <div style={{ display: 'flex', gap: '10px', flexShrink: 0 }}>
        <button
          onClick={decline}
          style={{
            background: 'transparent',
            border: '1px solid rgba(255,255,255,0.25)',
            color: 'rgba(255,255,255,0.6)',
            borderRadius: '8px',
            padding: '8px 16px',
            fontSize: '13px',
            cursor: 'pointer',
          }}
        >
          {t('cookie.decline')}
        </button>
        <button
          onClick={accept}
          style={{
            background: 'linear-gradient(135deg, #7c3aed, #9333ea)',
            border: 'none',
            color: '#fff',
            borderRadius: '8px',
            padding: '8px 16px',
            fontSize: '13px',
            fontWeight: '600',
            cursor: 'pointer',
          }}
        >
          {t('cookie.accept')}
        </button>
      </div>
    </div>
  );
}

export default CookieConsent;
